import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const InspectionFormAddItems = lazyLoader(
  () =>
    import(
      "Containers/Inspections/InspectionsFormsDashboard/InspectionFormAdd/InspectionFormAddItems/InspectionFormAddItems"
    )
);

export const InspectionFormsItems = () => {
  return (
    <Layout>
      <InspectionFormAddItems />
    </Layout>
  );
};
